import { z } from 'zod'
import { oc } from '@orpc/contract'
import { patientInvoiceKindSchema } from './copay-status.contract'

export const sendCopayLink = oc
  .route({ method: 'POST', path: '/v2/copay/{encounterId}/send-link' })
  .input(
    z
      .object({
        encounterId: z.string().min(1),
        kind: patientInvoiceKindSchema.default('copay'),
        channel: z.enum(['email', 'sms']),
        // E.164; required for the sms channel.
        phone: z
          .string()
          .regex(/^\+\d{8,15}$/, 'Phone must be in E.164 format, e.g. +18185550123')
          .optional(),
      })
      .refine((data) => data.channel !== 'sms' || Boolean(data.phone), {
        path: ['phone'],
        message: 'Phone is required for the sms channel',
      }),
  )
  .output(z.object({ sentTo: z.string() }))
